<template>
  <div>
    <b-navbar id="header" type="light" variant="light" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left" class="mr-1"/>
          Назад
        </b-button>
      </b-navbar-nav>

      <b-navbar-nav class="mx-2 mt-1">
        <template v-if="isBusy">
          <h4 id="invoice-ellipsis-loading">Загрузка счёта</h4>
        </template>
        <template v-else>
        <h4>{{title}}</h4>
        </template>
      </b-navbar-nav>

      <b-navbar-nav class="ml-2">
        <b-row align-v="center">
          <b-col>
            <span class="text-small">Статус</span>
            <b-badge pill :variant="getStatusStyle(newItem.paid_type)">
              {{getStatusName(newItem.paid_type)}}
            </b-badge>
          </b-col>
        </b-row>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto mr-3">
        <b-row align-v="center">
          <b-col>
            <b-overlay
              :show="loading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="success"
              class="d-inline-block"
              @hidden="onHiddenExportButtonOverlay"
            >
              <b-button ref="exportFileButton" size="sm" variant="info" @click.stop="exportFileGate('docx')">
                <font-awesome-icon icon="file" class="mr-1"/>
                Счёт в Docx
              </b-button>
            </b-overlay>

            <b-overlay
              :show="loading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="success"
              class="d-inline-block"
              @hidden="onHiddenExportPdfButtonOverlay"
            >
              <b-button ref="exportPdfFileButton" size="sm" variant="info" @click.stop="exportFileGate('pdf')">
                <font-awesome-icon icon="file-pdf" class="mr-1"/>
                Счёт в PDF
              </b-button>
            </b-overlay>
          </b-col>
        </b-row>
      </b-navbar-nav>

      <b-navbar-nav>
        <b-row align-v="center">
          <b-col cols="auto">
            <b-button size="sm" variant="success" :disabled="loading" @click="handleSubmit()">
              <b-spinner v-if="loading" small></b-spinner>
              <font-awesome-icon icon="save" class="mr-1" />
              Сохранить
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-skeleton-wrapper :loading="isBusy">
      <template #loading>
        <b-card no-body class="mb-2">
          <b-card-body class="p-3">
            <b-row>
              <b-col lg="7">
                <b-card no-body bg-variant="light">
                  <b-card-body>
                    <b-row class="mt-2 mb-3">
                      <b-col lg="4">
                        <b-skeleton width="36%" height="16%" class="mb-2"/>
                        <b-skeleton type="input" width="100%" height="28%" class="mb-2"/>
                        <b-skeleton width="80%" height="35%"/>
                      </b-col>
                      <b-col lg="4">
                        <b-skeleton width="22%" height="16%" class="mb-2"/>
                        <b-skeleton type="input" width="100%" height="28%"/>
                      </b-col>
                      <b-col lg="4">
                        <b-skeleton width="38%" height="16%" class="mb-2"/>
                        <b-skeleton type="input" width="100%" height="28%"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-3">
                      <b-col lg="6">
                        <b-skeleton width="46%" height="24%" class="mb-2"/>
                        <b-skeleton type="input" width="100%" height="43%"/>
                      </b-col>
                      <b-col lg="6">
                        <b-skeleton width="35%" height="24%" class="mb-2"/>
                        <b-skeleton type="input" width="100%" height="70%"/>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
                <b-row class="mt-2">
                  <b-col>
                    <b-skeleton type="input" width="100%" height="130%"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col lg="5">
                <b-card no-body bg-variant="light">
                  <b-card-header>
                    <b-skeleton width="13%" height="50%"/>
                  </b-card-header>
                  <b-list-group flush bg-variant="light">
                    <b-list-group-item
                      v-for="i in 8"
                      :key="'skeleton-item-' + i"
                      bg-variant="light"
                      class="d-flex justify-content-between align-items-center"
                      :class="{
                        'mb-2': i === 2 || i === 5 || i === 6,
                        'border-top': i === 3 || i === 6 || i === 7,
                      }"
                    >
                      <!-- Left -->
                      <div class="flex-grow-1">
                        <b-skeleton :width="getLeftSkeletonWidth(i)" height="20%" class="mb-0"/>
                      </div>
                      <!-- Right -->
                      <div>
                        <b-skeleton :width="getRightSkeletonWidth(i)" class="mr-5"/>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <b-tabs card>
          <b-tab title="Заявки" disabled/>
          <b-tab title="Работы" disabled/>
          <b-tab title="Акты" disabled/>
          <b-tab title="Оплаты" disabled/>
        </b-tabs>
        <b-card border-variant="white">
        <b-card no-body>
          <b-card-header>
            <b-row>
              <b-col cols="auto" align-v="center" class="mr-auto">
                <h5 class="text-muted">Заявки</h5>
              </b-col>
              <b-col cols="auto" class="mr-5">
                <b-skeleton type="input" width="260%" height="80%"/>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card no-body bg-variant="light">
            <div class="text-center text-muted d-flex align-items-center justify-content-center">
              <div class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
              <h5>Загрузка заявок</h5>
            </div>
          </b-card>
        </b-card>
        </b-card>
      </template>
    </b-skeleton-wrapper>

    <div v-show="!isBusy">
      <!--  Детали счёта  -->
      <b-card no-body class="mb-2">
        <b-card-body class="p-3">
          <b-row>
            <b-col lg="7">
              <b-card no-body bg-variant="light">
                <b-card-body>
                  <b-row>
                    <b-col lg="4">
                      <b-form-group
                        id="group-numb"
                        label="Счет №"
                        label-for="input-numb"
                        description="Для автоподстановки номера оставьте поле пустым или 0"
                      >
                        <b-form-input
                          id="input_numb"
                          size="sm"
                          autocomplete="off"
                          v-model.number="newItem.numb">
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="4">
                      <b-form-group
                        id="group-date"
                        label="Дата"
                        label-for="input-date"
                      >
                        <b-form-input
                          id="input-date"
                          size="sm"
                          type="date"
                          v-model.date="newItem.date"/>
                      </b-form-group>
                    </b-col>
                    <b-col lg="4">
                      <b-form-group
                        id="group-contract"
                        label="Договор"
                        label-for="input-contract"
                      >
                        <b-form-input
                          id="input_contract"
                          size="sm"
                          autocomplete="off"
                          v-model="newItem.contract">
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col lg="6">
                      <b-form-group
                        id="group_organization"
                        label="Организация продавец"
                        label-for="input_organization"
                      >
                        <template #label>
                          Организация
                          <b-link
                            class="text-decoration-none text-small text-body"
                            v-b-modal.modal-organization
                            v-b-tooltip.hover
                            title="Реквизиты"
                          >
                            <font-awesome-icon icon="id-card" />
                          </b-link>
                          <b-modal id="modal-organization" title="Реквизиты" ok-only size="lg">
                            <p>
                              {{selectedOrganization.full_name}} <br>
                              ИНН/КПП {{ selectedOrganization.inn }} / {{ selectedOrganization.kpp }}<br>
                              ОГРН {{ selectedOrganization.ogrn }}<br>
                              Адрес {{ selectedOrganization.address }}<br>
                              Расчетный счет {{ selectedOrganization.checking_account }}<br>
                              БИК {{ selectedOrganization.bik }} , {{ selectedOrganization.bank }} , Кор. счет {{ selectedOrganization.cor_account }}
                            </p>
                          </b-modal>
                        </template>
                        <b-form-select size="sm" id="input_organization" v-model="selectedOrganization">
                          <option v-for="option in organizations" :value="option">
                            {{ option.name }} (ИНН {{ option.inn }} / КПП {{ option.kpp }})
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6">
                      <b-form-group
                        id="group_customer"
                        label="Организация покупатель"
                        label-for="input_customer"
                      >
                        <template #label>
                          Заказчик
                          <b-link
                            v-if="customer.name"
                            class="text-decoration-none text-small text-body"
                            v-b-modal.modal-customer
                            v-b-tooltip.hover
                            title="Реквизиты"
                          >
                            <font-awesome-icon icon="id-card" />
                          </b-link>
                          <b-modal id="modal-customer" title="Реквизиты" ok-only size="lg">
                            <p class="text-small">
                              {{customer.full_name}} <br>
                              ИНН/КПП {{ customer.inn }} / {{ customer.kpp }}<br>
                              ОГРН {{ customer.ogrn }}<br>
                              Адрес {{ customer.address }}<br>
                              Расчетный счет {{ customer.checking_account }}<br>
                              БИК {{ customer.bik }} , {{ customer.bank }} , Кор. счет {{ customer.cor_account }}
                            </p>
                          </b-modal>
                        </template>

                        <div v-if="customer.name" >
                          <b-card no-body>
                            <div class="my-1 mx-2 text-small">
                              {{ customer.name ? customer.name + ' (ИНН ' + customer.inn + ' /  КПП ' + customer.kpp + ')' : "-" }}
                            </div>
                          </b-card>
                        </div>
                        <div v-else>Не определён</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>

              <b-alert
                class="mt-2"
                :show="true"
                :variant="this.newItem.summa !== this.totalPriceTasks ? 'danger' : 'success'"
              >
                {{ this.newItem.summa !== this.totalPriceTasks ?
                'Внимание! Сумма по счёту не совпадает с суммой по заявкам.' :
                'Сумма по счёту совпадает с суммой по заявкам.' }}
              </b-alert>
            </b-col>
            <b-col lg="5">
              <b-card no-body bg-variant="light">
                <b-card-header>
                  <h6 id="invoice-header">Итого</h6>
                </b-card-header>
                <b-list-group flush bg-variant="light">
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Сумма по счёту
                    <strong>{{priceFormat(this.newItem.summa)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Кол-во работ
                    <strong>{{this.newItem.works.length}}</strong>
                  </b-list-group-item>
                </b-list-group>
                <b-list-group flush bg-variant="light" class="mt-2">
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Кол-во заявок
                    <strong>{{this.tasks.length}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Единиц(часов, шт.) по заявкам
                    <strong>{{priceFormat(this.totalHoursTasks)}}</strong>
                  </b-list-group-item>
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Сумма по заявкам
                    <strong>{{priceFormat(this.totalPriceTasks)}}</strong>
                  </b-list-group-item>
                </b-list-group>
                <b-list-group flush bg-variant="light" class="mt-2">
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Кол-во актов
                    <strong>{{this.newItem.acts.length}}</strong>
                  </b-list-group-item>
                </b-list-group>
                <b-list-group flush bg-variant="light" class="mt-2">
                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Кол-во оплат
                    <strong>{{this.newItem.payments.length}}</strong>
                  </b-list-group-item>

                  <b-list-group-item bg-variant="light" class="d-flex justify-content-between align-items-center">
                    Сумма по оплатам
                    <strong>{{priceFormat(this.totalPaymentsSum)}}</strong>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-tabs card>
        <b-tab title="Заявки" active>
          <!--  Заявки  -->
          <b-card no-body>
            <b-card-header>
              <b-row align-v="center">
                <b-col cols="auto" class="mr-auto">
                  <h5 class="mb-0">Заявки</h5>
                </b-col>
                <b-col cols="auto">
                  <b-button size="sm" variant="success" @click.stop="onAddTask()">
                    <font-awesome-icon icon="plus" class="mr-1"/>
                    Добавить
                  </b-button>
                </b-col>
              </b-row>
            </b-card-header>

            <b-table
              id="invoice-tasks"
              ref="invoice-tasks"
              class="mb-0"
              selectable
              select-mode="single"
              selectedVariant="success"
              striped
              small
              thead-class="top-fixed-thead thead-light"
              table-class="text-small"
              responsive
              show-empty
              :empty-text="$t('message.common.emptyTable')"
              :items="tasks"
              :fields="fields"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Загрузка</strong>
                </div>
              </template>

              <template #cell(location_name)="row">
                <div v-if="row.item.location_name.length<100">{{ row.item.location_name }}</div>
                <div v-else>{{ row.item.location_name.substring(0, 100) + ".." }}</div>
                <p class="m-0 p-0 text-secondary text-small">{{row.item.customer_name}}</p>
              </template>

              <template #cell(start_date)="row">
                {{formatTableDateTime(row.item.start_date)}}
              </template>

              <template #cell(total_price)="row">
                {{priceFormat(row.item.total_price)}}
              </template>

              <template #cell(paid)="row">
                {{paid(row)}}
              </template>

              <template #cell(read_only)="row">
                <font-awesome-icon :icon="['fas', readOnly(row).icon]" :style=readOnly(row).style />
              </template>

              <template #cell(action)="row">
                <b-btn size="sm" variant="danger" @click="onRemoveTask(row)">
                  <font-awesome-icon icon="trash"/>
                </b-btn>
              </template>
            </b-table>

            <b-card-footer footer-bg-variant="light">
              <b-row align-h="between" align-v="center">
                <b-col cols="auto" class="mr-auto">
                  Кол-во заявок: <b>{{this.tasks.length}}</b> |
                  <span v-html="workTypeHours"></span> |
                  Сумма по заявкам: <b>{{priceFormat(this.totalPriceTasks)}}</b> |
                  Всего работ: <b>{{this.newItem.works.length}}</b> |
                  Сумма по счёту: <b>{{priceFormat(this.newItem.summa)}}</b>
                </b-col>
                <b-col cols="auto">
                  <b-pagination
                    id="invoice-tasks-pagination"
                    pills
                    :total-rows="this.tasks.length"
                    :per-page="perPage"
                    v-model="currentPage"/>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-tab>

        <b-tab title="Работы">
          <!--  Работы  -->
          <b-card no-body>
            <b-card-header>
              <b-row align-v="center">
                <b-col cols="auto" class="mr-auto">
                  <h5 class="mb-0">Работы</h5>
                </b-col>
                <b-col cols="auto">
                  <b-button size="sm" variant="success" @click.stop="onAddWork()">
                    <font-awesome-icon icon="plus" class="mr-1"/>
                    Добавить
                  </b-button>
                </b-col>
              </b-row>
            </b-card-header>

            <b-table
              id="invoice-works"
              ref="invoice-works"
              class="mb-0"
              selectable
              select-mode="single"
              selectedVariant="success"
              striped
              small
              thead-class="top-fixed-thead thead-light"
              table-class="text-small"
              responsive
              show-empty
              :empty-text="$t('message.common.emptyTable')"
              :items="newItem.works"
              :fields="worksFields"
              :per-page="worksPerPage"
              :current-page="worksCurrentPage"
              :sort-by.sync="worksSortBy"
              :sort-desc.sync="worksSortDesc"
              :sort-compare="sortCompare"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Загрузка</strong>
                </div>
              </template>

              <template #cell(index)="row">
                {{ row.index + 1 }}
              </template>

              <template #cell(work_type_id)="row">
                <b-form-select
                  id="input_work_type"
                  size="sm"
                  v-model="row.item.work_type_id"
                  :options="work_type_catalogs"
                  @change="updateName(row.item)"/>
              </template>


              <template #cell(name)="row">
                <b-form-input
                  id="input_name"
                  size="sm"
                  autocomplete="off"
                  v-model="row.item.name">
                </b-form-input>
              </template>

              <template #cell(price)="row">
                <b-form-input
                  id="input_price"
                  size="sm"
                  class="widthPrice"
                  autocomplete="off"
                  v-model.number="row.item.price">
                </b-form-input>
              </template>

              <template #cell(count)="row">
                <b-form-input
                  id="input_count"
                  size="sm"
                  class="widthPrice"
                  autocomplete="off"
                  v-model.number="row.item.count">
                </b-form-input>
              </template>

              <template #cell(nds)="row">
                {{ row.item.nds }}%
              </template>

              <template #cell(unit)="row">
                <unit-select id="input_unit" ref="unit_select" :initial-unit="row.item.unit_code" is-short v-on:selectUnit="updateUnit($event, row)" />
              </template>

              <template #cell(summa)="row">
                {{priceFormat(row.item.summa)}}
              </template>

              <template #cell(action)="row">
                <b-button size="sm" variant="danger" @click="onRemoveWork(row)">
                  <font-awesome-icon icon="trash" />
                </b-button>
              </template>
            </b-table>

            <b-card-footer footer-bg-variant="light">
              <b-row align-h="between" align-v="center">
                <b-col cols="auto" class="mr-auto">
                  Кол-во заявок: <b>{{this.tasks.length}}</b> |
                  Часов по заявкам: <b>{{priceFormat(this.totalHoursTasks)}}</b> |
                  Сумма по заявкам: <b>{{priceFormat(this.totalPriceTasks)}}</b> |
                  Всего работ: <b>{{this.newItem.works.length}}</b> |
                  Сумма по счёту: <b>{{priceFormat(this.newItem.summa)}}</b>
                </b-col>
                <b-col cols="auto">
                  <b-pagination
                    id="invoice-works-pagination"
                    pills
                    :total-rows="this.newItem.works.length"
                    :per-page="worksPerPage"
                    v-model="worksCurrentPage"/>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-tab>

        <b-tab title="Акты">
          <!--  Акты  -->
          <b-card no-body>
            <b-card-header>
              <b-row align-v="center">
                <b-col cols="auto" class="mr-auto">
                  <h5 class="mb-0">Акты</h5>
                </b-col>
                <b-col cols="auto">
                  <b-button size="sm" variant="success" @click.stop="onAddAct()">
                    <font-awesome-icon icon="plus" class="mr-1"/>
                    Создать
                  </b-button>
                </b-col>
              </b-row>
            </b-card-header>

            <b-table
              id="invoice-acts"
              ref="invoice-acts"
              class="mb-0"
              selectable
              select-mode="single"
              selectedVariant="success"
              striped
              small
              thead-class="top-fixed-thead thead-light"
              table-class="text-small"
              responsive
              show-empty
              :empty-text="$t('message.common.emptyTable')"
              :items="newItem.acts"
              :fields="actsFields"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Загрузка</strong>
                </div>
              </template>

              <template #cell(numb)="row">
                <b-form-input
                  id="input_number"
                  size="sm"
                  autocomplete="off"
                  v-model.number="row.item.numb">
                </b-form-input>
              </template>

              <template #cell(date)="row">
                <b-form-input
                  id="input_date"
                  size="sm"
                  type="date"
                  v-model.date="row.item.date"/>
              </template>

              <template #cell(contract)="row">
                <b-form-input
                  id="input_contract"
                  size="sm"
                  autocomplete="off"
                  v-model="row.item.contract">
                </b-form-input>
              </template>

              <template #cell(town)="row">
                <b-form-input
                  id="input_town"
                  size="sm"
                  autocomplete="off"
                  v-model="row.item.town">
                </b-form-input>
              </template>

              <template #cell(document)="row">
                <b-overlay
                  :show="loading"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="success"
                  class="d-inline-block"
                >
                  <b-button size="sm" variant="info" :disabled="row.item.id === 0" @click.stop="exportActFileGate(row, 'docx')">
                    <font-awesome-icon icon="file" class="mr-1"/>
                    Docx
                  </b-button>
                </b-overlay>

                <b-overlay
                  :show="loading"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="success"
                  class="d-inline-block"
                >
                  <b-button size="sm" variant="info" :disabled="row.item.id === 0" @click.stop="exportActFileGate(row, 'pdf')">
                    <font-awesome-icon icon="file-pdf" class="mr-1"/>
                    PDF
                  </b-button>
                </b-overlay>
              </template>

              <template #cell(action)="row">
                <b-button size="sm" variant="primary" @click="onEditAct(row.item)">
                  <font-awesome-icon icon="edit" />
                </b-button>
                <b-button size="sm" variant="danger" @click="onRemoveAct(row)">
                  <font-awesome-icon icon="trash" />
                </b-button>
              </template>
            </b-table>

            <b-card-footer footer-bg-variant="light">
              <b-row align-h="between" align-v="center">
                <b-col cols="auto" class="mr-auto">
                  Всего актов: <b>{{this.newItem.acts.length}}</b> |
                  Всего работ: <b>{{this.newItem.works.length}}</b> |
                  Сумма по счёту: <b>{{priceFormat(this.newItem.summa)}}</b>
                </b-col>
                <b-col cols="auto">
                  <b-pagination
                    id="invoice-acts-pagination"
                    pills
                    :total-rows="this.newItem.acts.length"
                    :per-page="actsPerPage"
                    v-model="actsCurrentPage"/>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-tab>

        <b-tab title="Оплаты">
          <!--  Оплаты  -->
          <b-card no-body>
            <b-card-header>
              <b-row align-v="center">
                <b-col cols="auto" class="mr-auto">
                  <h5 class="mb-0">Оплаты</h5>
                </b-col>
                <b-col cols="auto">
                  <b-button size="sm" variant="success" @click.stop="onAddPayment()">
                    <font-awesome-icon icon="plus" class="mr-1"/>
                    Добавить
                  </b-button>
                </b-col>
              </b-row>
            </b-card-header>

            <b-table
              id="invoice-payments"
              ref="invoice-payments"
              class="mb-0"
              selectable
              select-mode="single"
              selectedVariant="success"
              striped
              small
              thead-class="top-fixed-thead thead-light"
              table-class="text-small"
              responsive
              show-empty
              :empty-text="$t('message.common.emptyTable')"
              :items="newItem.payments"
              :fields="paymentsFields"
              :per-page="paymentsPerPage"
              :current-page="paymentsCurrentPage"
              :sort-by.sync="paymentsSortBy"
              :sort-desc.sync="paymentsSortDesc"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <div class="text-center text-success my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Загрузка</strong>
                </div>
              </template>

              <template #cell(numb)="row">
                <b-form-input
                  id="input_number"
                  size="sm"
                  autocomplete="off"
                  v-model.number="row.item.numb">
                </b-form-input>
              </template>

              <template #cell(date)="row">
                <b-form-input
                  id="input_date"
                  size="sm"
                  type="date"
                  v-model.date="row.item.date"/>
              </template>

              <template #cell(sum)="row">
                <b-form-input
                  id="input_contract"
                  size="sm"
                  class="widthPrice"
                  autocomplete="off"
                  v-model.number="row.item.sum">
                </b-form-input>
              </template>

              <template #cell(comment)="row">
                <b-form-input
                  id="input_town"
                  size="sm"
                  autocomplete="off"
                  v-model="row.item.comment">
                </b-form-input>
              </template>

              <template #cell(action)="row">
                <b-button size="sm" variant="danger" @click="onRemovePayment(row)">
                  <font-awesome-icon icon="trash" />
                </b-button>
              </template>
            </b-table>

            <b-card-footer footer-bg-variant="light">
              <b-row align-h="between" align-v="center">
                <b-col cols="auto" class="mr-auto">
                  Всего оплат: <b>{{this.newItem.payments.length}}</b> |
                  Сумма по оплатам: <b>{{priceFormat(this.totalPaymentsSum)}}</b> |
                  Всего работ: <b>{{this.newItem.works.length}}</b> |
                  Сумма по счёту: <b>{{priceFormat(this.newItem.summa)}}</b>
                </b-col>
                <b-col cols="auto">
                  <b-pagination
                    id="invoice-payments-pagination"
                    pills
                    :total-rows="this.newItem.payments.length"
                    :per-page="paymentsPerPage"
                    v-model="paymentsCurrentPage"/>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </b-tab>
      </b-tabs>
    </div>

    <invoice-tasks-select ref="invoiceTaskSelect" :tasks=tasks v-on:addToInvoice="addToInvoice"/>

    <export-file ref="exportFile"/>

    <invoice-act ref="invoice_act" v-on:update="updateInvoiceActs"/>
  </div>
</template>

<script>
import invoices from "../../network/invoices";
import catalogs from "../../network/catalogs";
import users from "../../network/users";
import organizations from "../../network/organizations";
import customers from "../../network/customers";
import locations from "../../network/locations";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import invoiceDocumentPatcher from "../../utilites/invoiceDocumentPatcher";
  import unitStore from "../../utilites/unitStore";
  import invoiceActPatcher from "../../utilites/invoiceActPatcher";
  import {rubles} from 'rubles';
  import { parse } from "content-disposition-attachment";
    import InvoiceTasksSelect from "./InvoiceTasksSelect";
    import UnitSelect from "../Catalogs/UnitSelect";
    import ExportFile from "./ExportFile";
    import InvoiceAct from "./InvoiceAct"

export default {
  name: "Invoice",
  components: { UnitSelect, InvoiceTasksSelect, ExportFile, InvoiceAct },
  mixins: [
    invoices, catalogs, users, organizations, customers, locations,
    helpers, dateFormatter, invoiceDocumentPatcher, unitStore, invoiceActPatcher
  ],
  data() {
    return {
      title:'Новый счёт',
      newItem: {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        summa: 0,
        customer_id: 0,
        organization_id: 0,
        active: true,
        tasks: [],
        paid_type: 0,
        works: [],
        acts: [],
        payments: [],
      },
      user: {},
      executors: [],
      isBusy: true,
      customer: {
        id: 0,
        name: ''
      },
      paidTypes: [
        { id: 0, name: "Не оплачено" },
        { id: 1, name: "Оплачено" },
        { id: 2, name: "Частично оплачено" },
        { id: 3, name: "Переплата"}
      ],
      customersUrl: 'customers',
      selectedOrganization: {},
      organizations: [],
      perPage: 100,
      currentPage: 1,
      tasks: [],
      fields: [
        {
          key: 'id',
          sortable: true,
        },
        {
          key: 'location_name',
          label: 'Объект',
          sortable: true,
          class: 'invoice-tasks-address'
        },
        {
          key: 'start_date',
          label: this.$t('message.tasks.table.start_date'),
          sortable: true,
          class:'widthDate'
        },
        {
          key: 'workers_count',
          label: this.$t('message.tasks.table.workers_count'),
          sortable: true,
        },
        {
          key: 'payment_first',
          label: 'Стоимость ед.',
          sortable: true,
        },
        {
          key: 'total_hours',
          label: 'Кол-во ед.',
          sortable: true,
        },
        {
          key: 'total_price',
          label: this.$t('message.tasks.table.total_price'),
          sortable: true,
        },
        {
          key: 'executor_name',
          label: this.$t('message.tasks.table.executor_name'),
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
        },
      ],
      work_type_catalogs: [],
      worksPerPage: 10,
      worksCurrentPage: 1,
      worksFields: [
        {
          key: 'index',
          label: '№',
          class: 'widthIndex',
          sortable: false
        },
        {
          key: 'work_type_id',
          label: 'Вид работ',
          class: 'widthCatalog',
          sortable: false
        },
        {
          key: 'name',
          label: 'Наименование',
          sortable: false
        },
        {
          key: 'price',
          label: 'Цена',
          class: 'widthPrice',
          sortable: false
        },
        {
          key: 'count',
          label: 'Количество',
          class: 'widthPrice',
          sortable: false
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          class: 'widthPrice',
          sortable: false
        },
        {
          key: 'nds',
          label: 'НДС',
          class: 'widthPrice',
          sortable: false
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
          sortable: false
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom',
          sortable: false
        },
      ],
      worksSortBy: 'id',
      worksSortDesc: false,
      nds: 0,
      actsPerPage: 10,
      actsCurrentPage: 1,
      actsFields: [
        {
          key: 'numb',
          label: 'Акт №',
        },
        {
          key: 'date',
          label: 'Дата',
        },
        {
          key: 'contract',
          label: 'Договор (№ и Дата)',
        },
        {
          key: 'town',
          label: 'Место составления (населённый пункт)',
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'align-middle'
        },
        {
          key: 'document',
          label: "Документ",
          class: 'widthCatalog',
          tdClass: 'align-bottom'
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom'
        },
      ],
      paymentsPerPage: 10,
      paymentsCurrentPage: 1,
      paymentsFields: [
        {
          key: 'numb',
          label: '№ Оплаты',
          class: 'widthPrice',
          sortable: false
        },
        {
          key: 'date',
          label: 'Дата',
          class: 'widthCatalog',
          sortable: true
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
          sortable: false
        },
        {
          key: 'comment',
          label: 'Комментарий',
          sortable: false
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom',
          sortable: false
        },
      ],
      paymentsSortBy: 'date',
      paymentsSortDesc: true,
      loading: true,
      leftSkeletonWidth: {  1: '38%', 2: '33%', 3: '35%', 4: '72%', 5: '44%', 6: '32%', 7: '32%', 8: '45%' },
      rightSkeletonWidth: {  1: '100%', 2: '50%', 3: '50%', 4: '50%', 5: '100%', 6: '50%', 7: '50%', 8: '50%' },
    }
  },
  async created() {
    const userInfoResult = await this.getUserInfo();
    this.user = userInfoResult.data;
    const usersResult = await this.getUsers();
    this.executors = usersResult.data.items;
    const organizationsResult = await this.getOrganizations();
    this.organizations = organizationsResult.data.items;
    this.work_type_catalogs = await this.getWorkTypeCatalogOptions();

    await this.updateView();
  },
  computed: {
    totalPriceWorks() {
      return this.newItem.works
        .map(obj => obj.sum)
        .reduce((acc, current) => acc + current, 0)
    },
    totalPriceTasks() {
      return this.tasks
        .map(obj => obj.total_price)
        .reduce((acc, current) => acc + current, 0)
    },
    totalHoursTasks() {
      return this.tasks
        .map(obj => obj.total_hours)
        .reduce((acc, current) => acc + current, 0)
    },
    workTypeHours() {
      // Считаем часы по work_type_id
      const hoursByWorkType = this.tasks.reduce((acc, task) => {
        acc[task.work_type_id] = (acc[task.work_type_id] || 0) + task.total_hours;
        return acc;
      }, {});
      // Формируем строку
      const workTypeHoursString = this.work_type_catalogs.map(catalogItem => {
        const workTypeId = catalogItem.value;
        const hours = hoursByWorkType[workTypeId];

        if (hours > 0) {
          return `${catalogItem.text} (часы): <b>${this.priceFormat(hours)}</b>`;
        } else {
          return null;
        }
      }).filter(Boolean);

      return workTypeHoursString.join(' | ');
    },
    totalText() {
      const sum = this.newItem.summa;
      if (sum) {
        return rubles(sum);
      }
      return "0";
    },
    totalPaymentsSum() {
      return this.newItem.payments
        .map(obj => obj.sum)
        .reduce((acc, current) => acc + current, 0)
    },

  },
  methods: {
    stopLoadingView() {
      setTimeout(function() {
        this.isBusy = false;
        this.loading = false;
      }.bind(this), 500);
    },
    async updateView() {
      // Открываем уже созданный счёт
      const invoiceId = this.$route.params.invoice_id;
      if (invoiceId) {
        await this.getInvoice(invoiceId);
        this.stopLoadingView();
        return;
      }

      this.stopLoadingView();

      // Создаем новый счёт с переданными из вне заявками
      const tasks = this.$route.params.tasks;
      if (tasks != null) {
        this.addToInvoice(tasks);
        return;
      }

      // Создаем новый счёт и открываем добавление заявок
      this.onAddTask();
    },
    async getInvoice(invoiceId) {
      const invoiceResult = await this.getInvoiceById(invoiceId);

      if (!invoiceResult || !invoiceResult.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.newItem = invoiceResult.data;

      this.title = `Счёт №${this.newItem.numb}`;

      const date = new Date(invoiceResult.data.date);
      this.newItem.date = this.formatDate(date);

      this.tasks = invoiceResult.data.tasks;
      const firstTask = this.tasks[0];
      if (firstTask) {
        if (firstTask.payment_type_int === 0) {
          this.nds = 0; // физ лицо
        } else if (firstTask.payment_type_int === 1) {
          this.nds = 22; // юр лицо
        } else if (firstTask.payment_type_int === 2) {
          this.nds = 0; // ИП
        } else if (firstTask.payment_type_int === 3) {
          this.nds = 22; // юр лицо смз
        }
      }

      let acts = this.newItem.acts;
      acts.forEach(function (act) {
        act.date = this.formatDate(new Date(act.date));
      }.bind(this));
      this.newItem.acts = acts;

      let payments = this.newItem.payments;
      payments.forEach(function (pay) {
        pay.date = this.formatDate(new Date(pay.date));
      }.bind(this));
      this.newItem.payments = payments;

      //this.updateWorks();

      await this.getCustomer(this.newItem.customer_id);
      await this.getOrganization(this.newItem.organization_id);
    },
    onBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/invoices').catch(()=>{});
      }
    },
    async handleSubmit() {
      this.newItem.customer_id = this.customer.id;

      if (this.tasks.length === 0) {
        this.showSubmitError("Добавьте заявки.");
        return;
      }

      if (this.newItem.customer_id === 0) {
        this.showSubmitError("Не заполнена организация Заказчик. Для заполнения добавьте заявки.");
        return;
      }

      if (this.selectedOrganization.id == null) {
        this.showSubmitError("Выберите организацию продавца.");
        return;
      }

      if (!this.isDateValid(this.newItem.date)) {
        this.showSubmitError("Выберите дату выставления счёта.");
        return;
      }

      const date = this.formatServerDate(new Date(this.newItem.date));

      let summa = this.newItem.summa;
      summa = Math.trunc(summa * 100) / 100;

      const taskIds = this.tasks.map(obj => obj.id);

      let acts = this.newItem.acts;
      acts.forEach(function (act) {
        if (act.numb === '') {
          act.numb = 0;
        }
        act.date = this.formatServerDate(new Date(act.date));
      }.bind(this));

      let payments = this.newItem.payments;
      payments.forEach(function (pay) {
        pay.date = this.formatServerDate(new Date(pay.date));
      }.bind(this));

      if (this.newItem.numb === '') {
        this.newItem.numb = 0;
      }

      const data = {
        id: this.newItem.id,
        date: date,
        summa: summa,
        customer_id: this.newItem.customer_id,
        organization_id: this.selectedOrganization.id,
        active: this.newItem.active,
        task_ids: taskIds,
        paid_type: this.newItem.paid_type,
        works: this.newItem.works,
        numb: this.newItem.numb,
        acts: acts,
        payments: payments,
        contract: this.newItem.contract
      }

      let invoiceResult;
      if (data.id > 0) {
        invoiceResult = await this.putInvoice(data);
      } else {
        invoiceResult = await this.postInvoice(data);
      }

      if (invoiceResult.error) {
        this.showError("Проверьте правильность заполнения полей", invoiceResult.error.message);
        return;
      }

      if (!invoiceResult || !invoiceResult.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        return;
      }

      this.newItem.id = invoiceResult.data.id;
      this.onBack();
    },
    async getCustomer(customer_id) {
      const customerResult = await this.getCustomerById(customer_id);
      this.customer = customerResult.data;
    },
    async getOrganization(organization_id) {
      const organizationResult = await this.getOrganizationById(organization_id);
      this.selectedOrganization = organizationResult.data;
    },
    async getWorkTypeCatalogOptions(data) {
      const result = await this.getWorkTypeCatalogs(data);
      const catalogs = result.data ? result.data.items : null;

      return catalogs
        .sort((x, y) => (Number(y.active) - Number(x.active)))
        .map(e => ({ value: e.id, text: e.name, disabled: !e.active }));
    },
    updateName(item) {
      const selectedOption = this.work_type_catalogs.find((option) => option.value === item.work_type_id);

      if (selectedOption) {
        item.name = `${selectedOption.text} (Объект:)`;
      } else {
        item.name = '';
      }
    },
    onAddTask() {
      if (this.$refs.invoiceTaskSelect != null) {
        this.$refs.invoiceTaskSelect.showModalSelect();
      }
    },
    async addToInvoice(tasks) {
      tasks.forEach(function (task) {
        if (this.existTask(task.id)) {
          return;
        }

        this.tasks.push(task);
      }.bind(this));

      const firstTask = this.tasks[0];
      if (firstTask) {
        await this.getCustomer(firstTask.customer_id);
        const location = (await this.getLocationById(firstTask.location_id)).data;
        if (location.organization_id > 0) {
          await this.getOrganization(location.organization_id)
        }

        if (firstTask.payment_type_int === 0) {
          this.nds = 0; // физ лицо
        } else if (firstTask.payment_type_int === 1) {
          this.nds = 22; // юр лицо
        } else if (firstTask.payment_type_int === 2) {
          this.nds = 0; // ИП
        } else if (firstTask.payment_type_int === 3) {
          this.nds = 22; // юр лицо смз
        }
      }

      this.newItem.summa = this.totalPriceWorks;
      //this.updateWorks();
    },
    existTask(id) {
      return this.tasks.find(x => x.id === id) !== undefined;
    },
    onRemoveTask(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      this.setModalDelete(
        row,
        "Удаление заявки",
        `${this.$t("message.tasks.modal.removeDesc")} № ${this.deleteRow.id}?`,
        this.tasks,
      );
    },
    // Для таблицы заявок
    paid(row) {
      return this.yesOrNoText(row.item.paid);
    },
    async exportFileGate(exportType) {
      const stampRes = await this.getStamps(this.newItem.organization_id);
      const ifHasStamp = stampRes.data.stamp || stampRes.data.director_sign;

      if (ifHasStamp !== "") {
        this.$refs.exportFile.show(function (hasStamp) {
          this.exportFile(this.newItem.id, exportType, hasStamp);
        }.bind(this));
      } else {
        await this.exportFile(this.newItem.id, exportType, false);
      }
    },
    onHiddenExportButtonOverlay() {
      this.$refs.exportFileButton.focus();
    },
    onHiddenExportPdfButtonOverlay() {
      this.$refs.exportPdfFileButton.focus();
    },
    getFileName(disposition) {
      const defaultName = "untitled";

      if (!disposition) return defaultName;

      try {
        const { attachment, filename } = parse(disposition);
        return attachment ? filename : defaultName;
      } catch (e) {
        console.error(e);
        return defaultName;
      }
    },
    async exportFile(id, exportType, hasStamp) {
      const data = { id, exportType, hasStamp }

      this.loading = true;
      const result = await this.getInvoiceFile(data);

      if (result.error || !result.data) {
        this.showGenerateFileError("Ошибка создания файла", "Не удалось выполнить создание файла. Попробуйте повторить позднее.");
        this.loading = false;
        return;
      }

      const fileName = this.getFileName(result.headers.get('content-disposition')).replace(/[+]/g,' ');

      this.handleFileDownload(result.data, fileName);
      this.loading = false;
    },
    async exportActFileGate(row, exportType) {
      const stampRes = await this.getStamps(this.newItem.organization_id);
      const ifHasStamp = stampRes.data.stamp || stampRes.data.director_sign || stampRes.data.accountant_sign;

      if (ifHasStamp !== "") {
      this.$refs.exportFile.show(function (hasStamp) {
        this.exportActFile(row.item.id, exportType, hasStamp);
      }.bind(this));
      } else {
        await this.exportActFile(row.item.id, exportType, false);
      }
    },
    async exportActFile(id, exportType, hasStamp) {
      const data = {id, exportType, hasStamp}

      this.loading = true;
      const result = await this.getInvoiceActFile(data);

      if (result.error || !result.data) {
        this.showGenerateFileError("Ошибка создания файла", "Не удалось выполнить создание PDF файла. Попробуйте повторить позднее.");
        this.loading = false;
        return;
      }

      const fileName = this.getFileName(result.headers.get('content-disposition')).replace(/[+]/g, ' ');

      this.handleFileDownload(result.data, fileName);
      this.loading = false;
    },
    onAddWork() {
      const work = {
        id: 0,
        work_type_id: null,
        name: '',
        price: null,
        count: null,
        unit_code: '539',
        nds: this.nds,
        sum: null
      };
      this.newItem.works.unshift(work);
      this.worksCurrentPage = 1;
      this.worksSortDesc = false;
    },
    onRemoveWork(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }

      this.setModalDelete(
        row,
        "Удаление работы",
        `Вы уверены, что хотите удалить ${this.deleteRow.name.toLowerCase()}?`,
        this.newItem.works,
      );
    },
    // Единицы измерения
    updateUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
    // Автоматическа подстановка Работ в зависимости от заявок. Не реализовано.
    updateWorks() {
      const work_type_ids = new Set(this.tasks.map(obj => obj.work_type_id));
      let works = [];
      work_type_ids.forEach(function (id, index) {
        const tasks = this.tasks.filter(item => item.work_type_id === id);
        const name = this.work_type_catalogs.find(x => x.id === id).name;
        const summa = tasks.reduce((acc, item) => acc + item.total_price_without_transfer, 0);
        const count = tasks.reduce((acc, item) => acc + item.total_hours, 0);
        let price = 0;
        if (count > 0) {
          price = summa / count;
        }

        const work = {
          index: index,
          id: id,
          name: name,
          price: price,
          count: count,
          units: 'чел.ч',
          nds: '22',
          summa: summa
        };
        works.push(work);
      }.bind(this));

      // Добавляем трансфер отдельным видом работ
      const count = this.tasks.reduce((acc, item) => acc + item.total_transfer_count, 0);

      if (count > 0) {
        const transferCatalogId = 2
        const name = this.work_type_catalogs.find(x => x.id === transferCatalogId).name;
        const transfer = this.tasks.reduce((acc, item) => acc + item.total_transfer_price, 0);
        const work = {
          index: work_type_ids.size + 1,
          id: transferCatalogId,
          name: name,
          price: transfer,
          count: count,
          units: 'шт',
          nds: '22',
          summa: transfer
        };
        works.push(work);
      }

      this.newItem.works = works;
    },
    // Акты
    onAddAct() {
      const completion = function(act) {
        this.newItem.acts.push(act);
      }.bind(this);

      const actWorks = this.newItem.works.map(function (item) {
        return {
          sort_index: item.sort_index,
          id: 0,
          work_type_id: item.work_type_id,
          name: item.name,
          price: item.price,
          count: item.count,
          unit_code: item.unit_code,
          nds: item.nds,
          sum: item.sum
        }
      });

      let newAct = {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        contract: '',
        town: '',
        active: true,
        works: actWorks,
      }
      this.$refs.invoice_act.showModal(newAct, this.nds, completion);
    },
    onEditAct(act) {
      const completion = function(updateAct) {
        act = updateAct;
      }.bind(this);

      this.$refs.invoice_act.showModal(act, this.nds, completion);
    },
    onRemoveAct(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      this.setModalDelete(
        row,
        "Удаление акта",
        `Вы уверены, что хотите удалить акт № ${this.deleteRow.numb}?`,
        this.newItem.acts,
      );
    },
    updateInvoiceActs(act) {
      this.newItem.acts.push(act);
    },
    // Оплаты
    onAddPayment() {
      const pay = {
        id: 0,
        numb: 0,
        date: this.formatDate(new Date()),
        sum: this.newItem.summa,
        comment: '',
      };
      this.newItem.payments.unshift(pay);
      this.paymentsCurrentPage = 1;
    },
    onRemovePayment(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      this.setModalDelete(
        row,
        "Удаление работы",
        `Вы уверены, что хотите удалить оплату № ${this.deleteRow.numb}?`,
        this.newItem.payments,
      );
    },
    setModalDelete(row, title, message, array) {
      this.showModalDelete(title, message, function () {
        const index = array.findIndex(item => item === row.item);
        array.splice(index, 1);
      }.bind(this));
    },
    updateStatus() {
      if (this.totalPaymentsSum == 0) {
        this.newItem.paid_type = 0;
        return;
      }

      if (this.totalPaymentsSum < this.newItem.summa) {
        this.newItem.paid_type = 2;
        return;
      }

      if (this.totalPaymentsSum === this.newItem.summa) {
        this.newItem.paid_type = 1;
        return;
      }

      if (this.totalPaymentsSum > this.newItem.summa) {
        this.newItem.paid_type = 3;
        return;
      }
    },
    // Статус
    getStatusName(status_id) {
      const status = this.paidTypes.find(e => e.id === status_id)
      return status != null ? status.name : 'Ошибка';
    },
    getStatusStyle(status_id) {
      switch (status_id) {
        case 0:
          return 'primary';
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'warning';
        default:
          return '';
      }
    },
    // Skeleton
    getLeftSkeletonWidth(i) {
      return this.leftSkeletonWidth[i];
    },
    getRightSkeletonWidth(i) {
      return this.rightSkeletonWidth[i];
    },
  },
  watch: {
    'newItem.works': {
      handler: function (newValues, _) {
        newValues.forEach(function (tw) {
          tw.sum = tw.count * tw.price;
        }.bind(this));

        this.newItem.summa = this.totalPriceWorks;
      },
      deep: true
    },
    'newItem.payments': {
      handler: function (newValues, _) {
        this.updateStatus();
      },
      deep: true
    }
  }
}
</script>

<style>
#invoice-tasks td {
  text-align: center;
  vertical-align: middle;
}

#invoice-tasks th {
  text-align: center;
  vertical-align: middle;
}

#invoice-tasks-pagination {
  margin-bottom: 0;
}

#invoice-works td {
  text-align: center;
}

#invoice-works th {
  text-align: center;
  vertical-align: middle;
}

#invoice-works-pagination {
  margin-bottom: 0;
}

#invoice-acts td {
  text-align: center;
}

#invoice-acts th {
  text-align: center;
  vertical-align: middle;
}

#invoice-acts-pagination {
  margin-bottom: 0;
}

#invoice-payments td {
  text-align: center;
}

#invoice-payments th {
  text-align: center;
  vertical-align: middle;
}

#invoice-payments-pagination {
  margin-bottom: 0;
}

.widthIndex {
  width: 50px;
}

.widthPrice {
  width: 120px;
}

.widthCatalog {
  width: 200px;
}

.invoice-tasks-address {
  min-width: 200px;
  text-align: left !important;
}

#modal-export-file .mb-3 {
  margin-bottom: 0 !important;
}

/* Skeleton table spinner */
.spinner {
  margin: 1%;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: #e0e0e0;
  height: 100%;
  width: 6px;
  display: inline-block;

  -webkit-animation: sk-stretchdelay 1.4s infinite ease-in-out;
  animation: sk-stretchdelay 1.4s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
       transform: scaleY(1.0);
       -webkit-transform: scaleY(1.0);
     }
}

#invoice-header {
  margin-bottom: 0 !important;
  margin-top: 0.5rem !important;
}

#invoice-ellipsis-loading {
  width: 170px;
  white-space: nowrap;
  display: inline-block;
}

@keyframes blink {
  0% { content: "."; }
  33% { content: ".."; }
  66% { content: "..."; }
  100% { content: "."; }
}

#invoice-ellipsis-loading::after {
  content: ".";
  animation: blink 1.5s infinite step-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Invoices/Invoice.vue